<style></style>

<i18n>
  {
  "ru": {
    "addItem": "Добавить новость",
    "name": "Название",
    "desc" : "Описание",
    "add": "Добавить",
    "image": "Картинка",
    "images": "Картинки",
    "create": "Создать",
    "save" : "Сохранить",
    "close": "Закрыть",
    "remove": "Удалить",
    "status": {
      "active" : "Активный",
      "disable": "Выключена"
    }
  },
  "uk": {
    "addItem": "Додати новину",
    "name": "Назва",
    "desc" : "Опис",
    "add": "Додати",
    "image": "Зображення",
    "images": "Картинки",
    "stock": "Знижка",
    "create": "Створити",
    "save" : "Зберегти",
    "close": "Закрити",
    "remove": "Вилучити",
    "status": {
      "active" : "Активний",
      "disable": "Вимкнений"
    }
  },
  "eng": {
    "addItem": "Add news",
    "name": "Name",
    "desc" : "Description",
    "add": "Add",
    "image": "Image",
    "images": "Images",
    "create": "Create",
    "save" : "Save",
    "close": "Close",
    "remove": "Remove",
    "status": {
      "active" : "Active",
      "disable": "Off"
    }
  }
  }
</i18n>

<template>
  <div>
    <div class="col-md-12">
      <button class="btn btn-primary" @click.prevent="showBlock = !showBlock">
        {{ $t("addItem") }}
      </button>
    </div>
    <hr />
    <div class="create-block" v-if="showBlock">
      <b-card>
        <form name="addItem" @submit.prevent="addItem">
          <div class="form-group">
            <label>{{ $t("name") }}:</label>
            <input
              type="text"
              name="name"
              required
              class="form-control"
              v-model="form.name[locale]"
            />
          </div>
          <div class="form-group">
            <label>{{ $t("desc") }}:</label>
            <ckeditor
              :editor="ck.editor"
              v-model="form.description[locale]"
              :config="ck.editorConfig"
            >
            </ckeditor>
          </div>
          <div class="form-group">
            <label>{{ $t("images") }}:</label>
            <file-pond
              name="image"
              ref="pond"
              label-idle="Для загрузки кликни или перетащи файл..."
              allow-multiple="true"
              allowImageResize="false"
              imageResizeUpscale="false"
              accepted-file-types="image/jpg, image/jpeg, image/png"
              server="https://may-ua.com.ua/uploader/upload-stroikomp.php"
              v-bind:files="myFiles"
              v-on:init="handleFilePondInit"
              @processfile="onLoad"
            />
          </div>
          <div class="btn-actions">
            <button type="submit" class="btn btn-primary btn-sm">
              {{ $t("create") }}
            </button>
            <button
              type="button"
              class="btn btn-link btn-sm"
              @click.prevent="showBlock = !showBlock"
            >
              {{ $t("close") }}
            </button>
          </div>
        </form>
      </b-card>
    </div>
    <div class="as-datatable">
      <b-table
        bordered
        striped
        hover
        small
        :items="$store.state.GlobalData.news"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
      >
        <template slot="index" slot-scope="row">
          {{ row.index + 1 }}
        </template>
        <template slot="name" slot-scope="row">
          <router-link
            :to="'/' + [locale] + '/news/' + row.item.id"
            class="as-link"
            target="_blank"
            >{{ row.item.name[locale] }}</router-link
          >
        </template>
        <template slot="custom" slot-scope="row">
          <div class="btn-actions">
            <button @click="row.toggleDetails" class="btn btn-primary btn-sm">
              <font-awesome-icon
                v-if="!row.detailsShowing"
                class="as-icon"
                :icon="['fas', 'pencil-alt']"
              />
              <font-awesome-icon
                v-else
                class="as-icon"
                :icon="['far', 'eye-slash']"
              />
            </button>

            <button
              class="btn btn-danger btn-sm"
              @click.prevent="removeEl(row)"
            >
              <font-awesome-icon class="as-icon" :icon="['fas', 'trash-alt']" />
            </button>
          </div>
        </template>
        <template slot="row-details" slot-scope="row">
          <b-card>
            <form action="#" method="POST" @submit.prevent="savePost(row)">
              <div class="form-group">
                <label>{{ $t("name") }}: </label>
                <input
                  class="form-control"
                  type="text"
                  name="name"
                  v-model="row.item.name[locale]"
                />
              </div>
              <div class="form-group">
                <label>{{ $t("desc") }}:</label>
                <ckeditor
                  :editor="ck.editor"
                  v-model="row.item.description[locale]"
                  :config="ck.editorConfig"
                >
                </ckeditor>
              </div>
              <div class="form-group">
                <label>{{ $t("images") }}:</label>
                <file-pond
                  name="image"
                  ref="pond"
                  label-idle="Для загрузки кликни или перетащи файл..."
                  allow-multiple="true"
                  allowImageResize="false"
                  imageResizeUpscale="false"
                  accepted-file-types="image/jpeg, image/png"
                  :server="{
                    process:
                      'https://may-ua.com.ua/uploader/upload-stroikomp.php',
                    load: 'https://s3.eu-central-1.amazonaws.com/img.stroikomp.com.ua/products/',
                  }"
                  @processfile="onLoadEdit"
                  @removefile="removeFileEdit"
                  v-bind:files="row.item.kostil"
                />
              </div>
              <div class="form-group">
                <label>Статус: </label>
                <select
                  class="form-control"
                  name="status"
                  v-model="row.item.status"
                >
                  <option value="default">Выберите статус</option>
                  <option value="0">Выключен</option>
                  <option value="1">Включен</option>
                </select>
              </div>
              <div class="actions-btn">
                <button class="btn btn-primary btn-sm" type="submit">
                  Сохранить
                </button>
                <button
                  class="btn btn-link btn-sm"
                  type="button"
                  @click.prevent="row.toggleDetails"
                >
                  Отменить
                </button>
              </div>
            </form>
          </b-card>
        </template>
      </b-table>
      <b-row>
        <b-col md="6" class="my-1">
          <b-pagination
            v-model="currentPage"
            :total-rows="$store.state.GlobalData.news.length"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginImageResize from "filepond-plugin-image-resize";
import FilePondPluginImageTransform from "filepond-plugin-image-transform";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Axios from "axios";

const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview,
  FilePondPluginImageResize,
  FilePondPluginImageTransform
);

export default {
  data() {
    return {
      currentPage: 1,
      perPage: 25,
      locale: this.$route.params.locale,
      newsAll: 0,
      showBlock: false,
      myFiles: [],
      news: [],
      form: {
        name: {
          ru: null,
          uk: null,
          eng: null,
        },
        images: [],
        description: {
          ru: "",
          uk: "",
          eng: "",
        },
        status: 1,
      },
      ck: {
        editor: ClassicEditor,
        editorConfig: {
          language: "ru",
        },
      },
      fields: {
        index: {
          key: "index",
          label: "№",
          sortable: true,
        },
        name: {
          key: "name",
          label: "Название",
          sortable: false,
        },
        status: {
          key: "status",
          label: "Статус",
          sortable: true,
        },
        custom: {
          label: "Действия",
          sortable: false,
        },
      },
    };
  },
  methods: {
    addItem() {
      let _this = this;
      let store = this.$store.state.GlobalData.news;
      Axios.post("/.netlify/functions/new-create", this.form).then(function (
        res
      ) {
        let newItem = {};
        _this.form.id = res.data.ref["@ref"].id;
        for (let key in _this.form) {
          newItem[key] = _this.form[key];
        }
        store.push(newItem);
        _this.showBlock = false;
        _this.form = clearForm();
      });
    },
    savePost(el) {
      Axios.post("/.netlify/functions/new-update", el.item)
        .then(() => {
          //this.$store.state.news = el.item;
          el.toggleDetails(false);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    removeEl(el) {
      if (confirm("Вы уверены?")) {
        let _this = this;
        Axios.post("/.netlify/functions/new-delete", { id: el.item.id })
          .then(function () {
            _this.$store.state.GlobalData.news.filter((f, i) => {
              if (f.id === el.item.id) {
                _this.$store.state.GlobalData.news.splice(i, 1);
              }
            });
          })
          .catch(function (err) {
            console.log(err);
          });
      } else {
        return null;
      }
    },
    handleFilePondInit: function () {
      this.$refs.pond.getFiles();
      console.log("init", this.$refs.pond);
      // FilePond instance methods are available on `this.$refs.pond`
    },
    onLoad(formData, file) {
      console.log(formData, file);
      const image = JSON.parse(file.serverId).full;
      this.form.images.push(image);
    },
    onLoadEdit(formData, file) {
      let store = this.$store.state.GlobalData.news;
      const image = JSON.parse(file.serverId).full;
      for (let i = 0; i < store.length; i++) {
        if (store[i]._showDetails) {
          if (!store[i].images) {
            store[i].images = [];
          }
          store[i].images.push(image);
          let imgObj = image.split("/");
          let obj = {
            source: imgObj
              .splice(imgObj.length === 7 ? 4 : 5, imgObj.length - 4)
              .join("/")
              .toString(),
            options: { type: "local" },
          };
          if (!store[i].kostil) {
            store[i].kostil = [];
          }
          store[i].kostil.push(obj);
        }
      }
    },
    removeFileEdit(formData, file) {
      let store = this.$store.state.GlobalData.news;
      for (let i = 0; i < store.length; i++) {
        if (store[i]._showDetails) {
          for (let img = 0; img < store[i].images.length; img++) {
            if (store[i].images[img].indexOf(file.source) !== -1) {
              store[i].images.splice(img, 1);
              store[i].kostil.splice(img, 1);
            }
          }
          console.log("store", store[i]);
        }
      }
    },
  },
  watch: {
    $route(to) {
      this.locale = to.params.locale;
    },
  },
  components: {
    FilePond,
  }
};

function clearForm() {
  let form = {
    name: {
      ru: null,
      uk: null,
      eng: null,
    },
    images: [],
    description: {
      ru: "",
      uk: "",
      eng: "",
    },
    status: 1,
  };
  return form;
}
</script>
